export const setIsScrolling = (payload) => async (dispatch) => {
    dispatch({
        type: "SET_IS_SCROLLING",
        payload,
    });
};
